import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import RB_RoomAreaPrint from "./RB_RoomAreaPrint";
import jspdf from "jspdf";
import axios from "axios";
import project, { requestURL } from "../config";
import Spinner from "../components/spinner";

const projectLogo = require(`../assets/${project.assets}/img/projectLogo.png`);

function OrderForm({ isShow, setHide, apiData, basePrice }) {
	const [submitted, setSubmitted] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);
	const formik = useFormik({
		initialValues: {
			firstName: "",
			lastName: "",
			phone: "",
			email: "",
			address: "",
			comment: "",
		},

		validationSchema: Yup.object({
			firstName: Yup.string()
				.max(20, "Der Vorname darf nicht länger als 20 Zeichen lang sein.")
				.required("Der Vorname ist erforderlich."),
			lastName: Yup.string()
				.max(20, "Der Nachname darf nicht länger als 20 Zeichen lang sein.")
				.required("Der Nachname ist erforderlich."),
			phone: Yup.string()
				.max(
					20,
					"Die Telefonnummer darf nicht länger als 20 Zeichen lang sein."
				)
				.required("Die Telefonnummer ist erforderlich"),
			email: Yup.string()
				.email("Ungültige E-Mail Addresse")
				.required("Die E-Mail Addresse ist erforderlich"),
			address: Yup.string().required("Die Addresse ist erforderlich"),
		}),

		onSubmit: (data) => {
			savePdf(data);
		},
	});

	const savePdf = (data) => {
		setShowSpinner(true);
		let pdfOption = {
			orientation: "p",
			unit: "mm",
			format: [210, 297],
			// hotfixes: ["px_scaling"],
			// putOnlyUsedFonts: true,
			compress: true,
		};

		var doc = new jspdf(pdfOption);

		doc.html(document.querySelector("#RoomBookPDF"), {
			callback: function (pdf) {
				const blob = doc.output("blob");
				const pdfToSend = new File(
					[blob],
					`RaumBuch-${apiData.unitInfo.unitName}.pdf`
				);
				let formData = new FormData();
				formData.append("firstname", data.firstName);
				formData.append("lastname", data.lastName);
				formData.append("email", data.email);
				formData.append("phone", data.phone);
				formData.append("address", data.address);
				formData.append("comment", data.comment);
				formData.append("session", apiData.unitInfo.session);
				formData.append("pdf", pdfToSend);

				axios({
					method: "POST",
					url: requestURL,
					data: formData,
				})
					.then(function (res) {
						setShowSpinner(false);
						setSubmitted(true);
					})
					.catch(function (res) {
						console.log("Error", res);
					});
			},
			x: 5,
			y: 5,
			// width: 790,
			// windowWidth: 790,
			width: 210,
			windowWidth: 800,
		});
	};

	let roomAreaMarkUpPrint;
	let unitArea = 0;
	let unitName;
	let priceBase = 0;
	let priceAdditional = 0;
	let priceReduction = 0;
	if (apiData) {
		// --------------------------------------------- PDF Markup Generator ------------------------------------

		const roomsDataCopy = JSON.parse(JSON.stringify(apiData.changeObj));
		// console.log(roomsDataCopy);

		let pageItemsNumber = 5; // Items per page
		let pageItemsRemain = pageItemsNumber - 1;
		let pageItems = [];
		let section = {
			roomArea: 0,
			roomName: "",
			surcharge: 0,
			selectedChoice: [],
		};
		let pages = [];
		let pageNumber = 1;
		let areaTotalPrice = 0;

		while (roomsDataCopy.length > 0) {
			let currentRoomObjCount = roomsDataCopy[0].selectedChoice.length;

			if (pageItemsRemain >= currentRoomObjCount) {
				section.roomArea = roomsDataCopy[0].roomArea;
				section.roomName = roomsDataCopy[0].roomName;
				section.selectedChoice = roomsDataCopy[0].selectedChoice;

				if (areaTotalPrice === 0) {
					for (let z = 0; z < roomsDataCopy[0].selectedChoice.length; z++) {
						areaTotalPrice +=
							roomsDataCopy[0].selectedChoice[z].choice.surcharge;
					}
				}

				section.surcharge = areaTotalPrice;

				pageItems.push({ ...section });

				roomsDataCopy.shift();
				areaTotalPrice = 0;

				if (roomsDataCopy.length === 0) {
					pageItemsRemain = 0;
				} else {
					pageItemsRemain = pageItemsRemain - currentRoomObjCount;
				}
			} else {
				section.roomArea = roomsDataCopy[0].roomArea;
				section.roomName = roomsDataCopy[0].roomName;
				section.selectedChoice = [
					...roomsDataCopy[0].selectedChoice.slice(0, pageItemsRemain),
				];

				for (let z = 0; z < roomsDataCopy[0].selectedChoice.length; z++) {
					areaTotalPrice += roomsDataCopy[0].selectedChoice[z].choice.surcharge;
				}

				section.surcharge = areaTotalPrice;

				pageItems.push({ ...section });

				roomsDataCopy[0].selectedChoice.splice(0, pageItemsRemain);

				pageItemsRemain = 0;
			}
			if (pageItemsRemain === 0) {
				pageItems.push(pageNumber);
				pages.push(pageItems);

				pageNumber++;
				pageItemsRemain = pageItemsNumber;
				pageItems = [];
			}
		}

		roomAreaMarkUpPrint = pages.map((arr, id) => (
			<RB_RoomAreaPrint key={id} data={arr} pageNumber={pages.length} />
		));

		unitArea = apiData.unitInfo.unitArea;
		unitName = apiData.unitInfo.unitName;
		priceBase = basePrice;

		for (let i = 0; i < apiData.changeObj.length; i++) {
			for (let j = 0; j < apiData.changeObj[i].selectedChoice.length; j++) {
				priceAdditional +=
					apiData.changeObj[i].selectedChoice[j].choice.surcharge;
			}
		}
	}
	const cancelForm = (e) => {
		e.preventDefault();
		setSubmitted(false);
		setHide(false);
		formik.resetForm();
		return false;
	};

	priceReduction = (priceBase + priceAdditional) * 0.03;
	priceReduction = Math.round(priceReduction * 100) / 100;

	const isShowClass = isShow === false ? "RBuch--hide" : "";
	if (submitted) {
		return (
			<div className={"RBuchContainer " + isShowClass}>
				<div className="RBuchBG" onClick={() => setHide(false)}></div>
				<div className="RBuchWindow">
					<button onClick={() => setHide(false)} className="RBuch-mobileBack">
						X
					</button>
					<div className="RBuch-UpperSection">
						Vielen Dank für Ihre Anfrage.
						<div className="formActionContainer">
							<button className="formButton" onClick={cancelForm}>
								Abbrechen
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
	return (
		<div className={"RBuchContainer " + isShowClass}>
			<div className="RBuchBG" onClick={() => setHide(false)}></div>
			<div className="RBuchWindow">
				<button onClick={() => setHide(false)} className="RBuch-mobileBack">
					X
				</button>
				<div className="RBuch-UpperSection">
					<form onSubmit={formik.handleSubmit} className="orderForm">
						<div>
							{/* First Name input field */}
							<div>
								<label
									htmlFor="firstName"
									className={`formLabel ${
										formik.touched.firstName && formik.errors.firstName
											? "formTextError"
											: ""
									} `}
								>
									{formik.touched.firstName && formik.errors.firstName
										? formik.errors.firstName
										: "Vorname"}
								</label>
								<input
									className="formInput"
									type="text"
									name="firstName"
									placeholder="Vorname"
									onChange={formik.handleChange}
									value={formik.values.firstName}
									onBlur={formik.handleBlur}
								/>
							</div>
							{/* Last Name input field */}
							<div>
								<label
									htmlFor="lastName"
									className={`formLabel ${
										formik.touched.lastName && formik.errors.lastName
											? "formTextError"
											: ""
									} `}
								>
									{formik.touched.lastName && formik.errors.lastName
										? formik.errors.lastName
										: "Nachname"}
								</label>
								<input
									className="formInput"
									type="text"
									name="lastName"
									placeholder="Nachname"
									onChange={formik.handleChange}
									value={formik.values.lastName}
									onBlur={formik.handleBlur}
								/>
							</div>
							{/* Phone input field */}
							<div>
								<label
									htmlFor="phone"
									className={`formLabel ${
										formik.touched.phone && formik.errors.phone
											? "formTextError"
											: ""
									} `}
								>
									{formik.touched.phone && formik.errors.phone
										? formik.errors.phone
										: "Telefonnummer"}
								</label>
								<input
									className="formInput"
									type="text"
									name="phone"
									placeholder="Telefonnummer"
									onChange={formik.handleChange}
									value={formik.values.phone}
									onBlur={formik.handleBlur}
								/>
							</div>
							{/* Email input field */}
							<div>
								<label
									htmlFor="email"
									className={`formLabel ${
										formik.touched.email && formik.errors.email
											? "formTextError"
											: ""
									}`}
								>
									{formik.touched.email && formik.errors.email
										? formik.errors.email
										: "Email Addresse"}
								</label>
								<input
									className="formInput"
									type="email"
									name="email"
									placeholder="EMail Adresse"
									onChange={formik.handleChange}
									value={formik.values.email}
									onBlur={formik.handleBlur}
								/>
							</div>

							{/* Address input field */}
							<div>
								<label
									htmlFor="address"
									className={`formLabel ${
										formik.touched.address && formik.errors.address
											? "formTextError"
											: ""
									}`}
								>
									{formik.touched.address && formik.errors.address
										? formik.errors.address
										: "Addresse"}
								</label>
								<textarea
									className="formInput"
									name="address"
									placeholder="Adresse"
									onChange={formik.handleChange}
									value={formik.values.address}
									onBlur={formik.handleBlur}
								/>
							</div>

							{/* Comment input field */}
							<div>
								<label
									htmlFor="comment"
									className={`formLabel ${
										formik.touched.comment && formik.errors.comment
											? "formTextError"
											: ""
									}`}
								>
									{formik.touched.comment && formik.errors.comment
										? formik.errors.comment
										: "Kommentar"}
								</label>
								<textarea
									className="formInput"
									name="comment"
									placeholder="Kommentar"
									onChange={formik.handleChange}
									value={formik.values.comment}
									onBlur={formik.handleBlur}
								/>
							</div>
							<div className="formActionContainer">
								<button className="formButton" onClick={cancelForm}>
									Abbrechen
								</button>
								<button type="submit" className="formButton">
									Anfrage Senden
								</button>
							</div>
						</div>
					</form>
				</div>
				<Spinner showSpinner={showSpinner} />
			</div>

			{/* --------------------------------- PDF SECTION --------------------------------- */}
			<div className="RBuchWindow--Print">
				<div id="RoomBookPDF" className="RBuch-UpperSection--Print">
					<div className="RBuch-Header-Print">
						<div className="RBuch-HLeft-Print">
							<img
								className="RBuch-HeaderLogo-Print"
								src={projectLogo}
								alt="Print Logo"
							/>
							<span className="RBuch-RoomName-Print">{unitName}</span>

							<span className="RBuch-RoomSize-Print">
								{unitArea.toLocaleString("de-DE", {
									maximumFractionDigits: 2,
								})}{" "}
								m2
							</span>
						</div>
						<div className="RBuch-HRight-Print">
							<div className="RBuch-PriceRow-Print">
								<span>Grundpreis:</span>
								<span>
									{priceBase.toLocaleString("de-DE", {
										style: "currency",
										currency: "EUR",
										maximumFractionDigits: 2,
									})}
								</span>
							</div>
							<div className="RBuch-PriceRow-Print">
								<span>Aufpreis:</span>
								<span>
									{priceAdditional.toLocaleString("de-DE", {
										style: "currency",
										currency: "EUR",
										maximumFractionDigits: 2,
									})}
								</span>
							</div>
							<div className="RBuch-PriceSum RBuch-PriceSum-Print">
								<span>Summe</span>
								<span>
									{(priceBase + priceAdditional).toLocaleString("de-DE", {
										style: "currency",
										currency: "EUR",
										maximumFractionDigits: 2,
									})}
								</span>
							</div>
							<div className="RBuch-PriceRow-Print">
								<span>Ihr Preisnachlass 3%:</span>
								<span>
									{priceReduction.toLocaleString("de-DE", {
										style: "currency",
										currency: "EUR",
										maximumFractionDigits: 2,
									})}
								</span>
							</div>
							<div className="RBuch-PriceRow-Print">
								<span>Ihr Kaufpreis:</span>
								<span>
									{(
										priceBase +
										priceAdditional -
										priceReduction
									).toLocaleString("de-DE", {
										style: "currency",
										currency: "EUR",
										maximumFractionDigits: 2,
									})}
								</span>
							</div>
						</div>
					</div>

					{roomAreaMarkUpPrint}
				</div>
				<div className="RBuch-LowerSection RBuch-LowerSection--Print">
					<button onClick={() => setHide(false)}>Back</button>
				</div>
			</div>
		</div>
	);
}

export default OrderForm;
